import React from "react";
import PlayQuiz from "../Qbank/PlayQuiz/PlayQuiz";

import "./PlayTest.scss";

export default function PlayTest() {
  return <PlayQuiz isTest={true} />;
}
